import uid from "common/utils/uid";
import type { DocMigration } from "../docMigration";

const OPTION_SET_HASH_PREFIX = "optionSet.";

/**
 * Moves component-owned option sets from componentMembers into componentAssociations.
 */
const migration: DocMigration = {
  id: "20260709_option_set_component_associations",
  description: "Move option set component membership from componentMembers to componentAssociations",
  apply(json, warnings: string[]) {
    const { optionSets, components } = json;
    const componentMembers = json.componentMembers as Record<string, string>;
    const componentAssociations = {};

    for (const [hash, componentId] of Object.entries(componentMembers) as [string, string][]) {
      if (!hash.startsWith(OPTION_SET_HASH_PREFIX)) {
        continue;
      }

      const optionSetId = hash.slice(OPTION_SET_HASH_PREFIX.length);
      if (!optionSetId) {
        delete componentMembers[hash];
        continue;
      }

      if (!optionSets[optionSetId] || !components[componentId]) {
        delete componentMembers[hash];
        warnings.push(
          `option_set_component_associations: removed stale componentMembers entry for option set ${optionSetId}`,
        );
        continue;
      }

      const associationId = uid();
      componentAssociations[associationId] = {
        id: associationId,
        entityType: "OPTION_SET",
        entityId: optionSetId,
        componentId,
        sortIndex: 0,
      };

      delete componentMembers[hash];
    }

    json.componentMembers = componentMembers;
    json.componentAssociations = componentAssociations;
    return json;
  },
};

export default migration;
